import {
  readWorkspaceAgentSkillMonikerAttrs,
  WORKSPACE_AGENT_SKILL_MONIKER_NODE_NAME,
} from '~/components/v2/components/workspace/workspace-agent-panel/tiptap/workspaceAgentSkillMoniker';
import { type WorkspaceAgentComposerDoc } from '~/components/v2/components/workspace/workspace-agent-panel/utils/serializeWorkspaceAgentComposerContent';

export type WorkspaceAgentComposerSkillIdsResult = {
  skillIds: string[];
};

/** Distinct skill ids from skill moniker nodes in the composer document. */
export const collectWorkspaceAgentComposerSkillIds = (
  editor: WorkspaceAgentComposerDoc,
): WorkspaceAgentComposerSkillIdsResult => {
  const skillIds: string[] = [];
  const seen = new Set<string>();

  editor.state.doc.descendants((node) => {
    if (node.type.name !== WORKSPACE_AGENT_SKILL_MONIKER_NODE_NAME) {
      return undefined;
    }

    const attrs = readWorkspaceAgentSkillMonikerAttrs(node.attrs);

    if (!attrs || seen.has(attrs.skillId)) {
      return undefined;
    }

    seen.add(attrs.skillId);
    skillIds.push(attrs.skillId);

    return undefined;
  });

  return { skillIds };
};
